import Repository from "./Repository";

const REGISTER = "elearning/caregiver/auth/signupWithPassword";
const GENERATE_OTP = "/auth/GenerateOTP";
const VERIFYOTP = "/auth/VerifyOTP";
const PASSWORD_CHANGE_REQ = "/auth/passwordChangeRequest";
const PASSWORD_CHANGE = "/auth/passwordChange";
const LOGIN = "/auth/loginWithPassword";
const LOGOUT = "/auth/logout";
const FORGOT_PASSWORD = "/auth/forgotPassword";
const UPDATE_USER_DETAILS = "/auth/updateUserDetails";
const UPDATE_USER_PROFILE = "/auth/updateUserImage";
const UPDATE_USER_COVER_IMAGE = "/auth/updateUserCoverImage";
const GOOGLE_SIGNUP = "/auth/signUpWithGoogle";
const LINKEDIN_SIGNUP = "/auth/signUpWithLinkedin";
const WHATSAPP_SIGNUP = "/auth/signUpWithWhatsapp";
const GOOGLE_LOGIN = "/auth/signInWithGoogle";
const GET_USER_BY_USER_ID = "/auth/getUserByUserId";
const GET_USER = "/auth/getUser";

export default {
  signupWithPassword(payload) {
    return Repository.post(transformRoute(REGISTER), payload);
  },

  generateOTP(payload) {
    return Repository.post(transformRoute(GENERATE_OTP), payload);
  },
  VerifyOTP(payload) {
    return Repository.post(transformRoute(VERIFYOTP), payload);
  },
  PasswordChangeRequest(payload) {
    return Repository.post(transformRoute(PASSWORD_CHANGE_REQ), payload);
  },
  PasswordChange(payload) {
    return Repository.post(transformRoute(PASSWORD_CHANGE), payload);
  },
  loginWithPassword(payload) {
    return Repository.post(transformRoute(LOGIN), payload);
  },
  logout() {
    return Repository.post(transformRoute(LOGOUT));
  },
  forgotPassword(payload) {
    return Repository.post(transformRoute(FORGOT_PASSWORD), payload);
  },
  UpdateUserDetails(payload) {
    return Repository.post(transformRoute(UPDATE_USER_DETAILS), payload);
  },
  updateUserProfile(payload) {
    return Repository.post(transformRoute(UPDATE_USER_PROFILE), payload);
  },
  updateUserCoverImage(payload) {
    return Repository.post(transformRoute(UPDATE_USER_COVER_IMAGE), payload);
  },
  signUpWithGoogle(payload) {
    return Repository.post(transformRoute(GOOGLE_SIGNUP), payload);
  },
  signUpWithLinkedin(payload) {
    return Repository.post(transformRoute(LINKEDIN_SIGNUP), payload);
  },
  signUpWithWhatsapp(payload) {
    return Repository.post(transformRoute(WHATSAPP_SIGNUP), payload);
  },
  signInWithGoogle(payload) {
    return Repository.post(transformRoute(GOOGLE_LOGIN), payload);
  },
  getUserByUserId(payload) {
    return Repository.post(transformRoute(GET_USER_BY_USER_ID), payload);
  },
  getUser(payload) {
    return Repository.post(transformRoute(GET_USER), payload);
  },
};

const transformRoute = (route) => {
  return `${route}`;
};
